export const registerServiceWorker = (serviceWorker, logger = console) => {
    if (typeof serviceWorker?.register !== 'function') {
        return false;
    }

    try {
        const registrationPromise = serviceWorker.register('/service-worker.js');
        if (typeof registrationPromise?.then !== 'function') {
            throw new TypeError('Service Worker registration did not return a promise');
        }

        Promise.resolve(registrationPromise)
            .then((registration) => {
                logger.log('Service Worker registered successfully:', registration.scope);
            })
            .catch((error) => {
                logger.log('Service Worker registration failed:', error);
            });
        return true;
    } catch (error) {
        logger.log('Service Worker registration failed:', error);
        return false;
    }
};
